<div class="ui-tab w-100 h-100 flex-col gap-16">
  <div class="flex-row space-between-center">
    <!-- FILTERS -->
    <div class="filters-wrapper">
      <ui-search
        [searchQuery]="filtersForm.get('query').value"
        (onInput)="filtersForm.get('query').setValue($event)"
        [placeholder]="'ZONE_REGIONS.PLACEHOLDERS.SEARCH_BY_NAME' | translate"></ui-search>

      <ui-camera-select-button (click)="selectCameraFilter()"></ui-camera-select-button>

      <!--      <app-tag-filter [formControl]="filtersForm.controls.tagIds" [isCreateButtonVisibleSig]="false" selectWidth="100%"></app-tag-filter>-->
      <ui-button [text]="'DATABASE_TAGS.BUTTONS.CREATE'|translate"
                 (click)="create()">
      </ui-button>
    </div>
  </div>

  @let cameraIdsKeys = Object.keys(filtersForm.get('cameraIds').value ?? {});
  @let cameraIdsValues = Object.values(filtersForm.get('cameraIds').value ?? {});
  @let searchQuery = (filtersForm.get('query').value ?? '').trim();

  <!-- FILTER CHIPS -->
  @if (hasActiveFilters) {
    <div class="flex-row gap-8 flex-wrap start-center">
      <span class="ui-icon-cross c-p"
            [matTooltip]="'COMMON.CLEAR_FILTERS'|translate"
            (click)="cleanAllFilters()">
      </span>
      @if (searchQuery) {
        <ui-filter-chip class="filter-chip"
                        [title]="searchQuery"
                        [allowDelete]="true"
                        (removeClicked)="onRemoveQueryFilter()">
        </ui-filter-chip>
      }
      @if (cameraIdsKeys.length) {
      <!-- CAMERA CHIPS -->
      <div [matMenuTriggerFor]="camerasMenu"
           class="filter-chip camera-chip">
        <ui-filter-chip class="filter-chip"
                        [title]="cameraIdsKeys.length + ' ' + ('WALL_LIST.CAMERA_FILTER'|translate)"
                        [allowDelete]="false"></ui-filter-chip>
      </div>

      <mat-menu #camerasMenu="matMenu"
                xPosition="after"
                yPosition="below"
                class="property-chips-wrapper">
        <div class="flex-row flex-wrap gap-8 property-chips">
          <ng-container *ngFor="let camera of cameraIdsValues">
            <ui-filter-chip class="filter-chip"
                            [title]="selectCameras()[camera.cameraId].edgeOnly.name"
                            [allowDelete]="true"
                            (removeClicked)="onRemoveCameraFilter(camera.cameraId)">
            </ui-filter-chip>
          </ng-container>
        </div>
      </mat-menu>
      }
    </div>
  }

  <!-- TABLE -->
  <div class="h-100 min-h-0">
    <div class="h-100 min-h-0 flex-col">
      <div class="h-100 min-h-0">
        @if (selectIsLoading()) {
          <div class="w-100 h-100">
            <ui-preloader [color]="loaderColor.blue"></ui-preloader>
          </div>
        } @else {
          @switch (viewState()) {
            @case (viewStates.HAS_CONTENT) {
              @if (tableConfig(); as config) {
                <ui-dataset-table
                  [data]="selectZoneRegions()"
                  [config]="config"
                  (rowAction)="onRowAction($event)"
                  (loadMore)="onLoadMore()">
                </ui-dataset-table>
              }
            }
            @case (viewStates.NO_RESULTS) {
              <ui-no-data [imgSrc]="noResults.imgSrc"
                          [title]="noResults.title|translate">
              </ui-no-data>
            }
            @case (viewStates.INITIAL_EMPTY) {
              <ui-no-data [imgSrc]="initialEmpty.imgSrc"
                          [title]="initialEmpty.title|translate">
              </ui-no-data>
            }
          }
        }
      </div>
    </div>
  </div>
</div>

<!-- CELL TEMPLATES -->
<ng-template #countingCell let-row>
  <div class="flex-row gap-8 start-center">
    <ui-toggle
      (click)="$event.stopPropagation()"
      [disabled]="isProcessing(row._id)"
      [ngModel]="!!row.countingEnabled"
      (ngModelChange)="onToggleZoneCounting(row, $event)">
    </ui-toggle>
    <span class="counting-label" [class.counting-label-on]="row.countingEnabled">
      {{ (row.countingEnabled ? 'ZONE_REGIONS.TABLE.COUNTING_ON' : 'ZONE_REGIONS.TABLE.COUNTING_OFF') | translate }}
    </span>
  </div>
</ng-template>
